import React from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import NonPidInput from './Components'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'

function NonPidRegistration() {
  return (
    <div>


<DashboardLayout> 
    <DashboardNavbar/>
     < NonPidInput/>
   </DashboardLayout>
    </div>
  )
}

export default  NonPidRegistration